// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lpZFr","inner":"Footer_inner__9FmUU"};